/** Deployment environments recognised by every application in the workspace. */
export const APP_ENVIRONMENTS = ['development', 'test', 'staging', 'production'] as const;

/** Union of the recognised deployment environments. */
export type AppEnvironment = (typeof APP_ENVIRONMENTS)[number];

/** Log levels accepted by the backend logger, ordered from most to least verbose. */
export const LOG_LEVELS = ['trace', 'debug', 'info', 'warn', 'error', 'fatal'] as const;

/** Union of the accepted log levels. */
export type LogLevel = (typeof LOG_LEVELS)[number];

/** Narrows an arbitrary string to a known environment. */
export function isAppEnvironment(value: string): value is AppEnvironment {
  return (APP_ENVIRONMENTS as readonly string[]).includes(value);
}

/**
 * Environments where diagnostic detail such as stack traces may be surfaced.
 * Production and staging always receive redacted errors.
 */
export function isDiagnosticEnvironment(environment: AppEnvironment): boolean {
  return environment === 'development' || environment === 'test';
}
